var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M8.596 2.286v2.9H3.429v1.451h1.546l1.476 14.506h11.67l1.476-14.506h1.546v-1.45h-5.167V2.286zm1.476 2.9H14.5v-1.45h-4.428zM6.457 6.638h11.657l-1.33 13.055H7.788zm8.043 10.88h1.476V8.813H14.5zm-2.952 0h1.476V8.813h-1.476zm-2.953 0h1.476V8.813H8.596z",
  clipRule: "evenodd"
})));
export default SvgDelete;